// extracted by mini-css-extract-plugin
export default {"container":"Aaa-z","heading":"Baa-z","links":"Caa-z","linkBtn":"Daa-z","disabled":"Eaa-z","linkUppercaseBold":"Faa-z","copy":"Gaa-z","subCopy":"Haa-z"};